import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";
import env from "../../../env";
import { Trans } from "react-i18next";
import { renderToString } from "react-dom/server";
import { FILE_NAME_PREFIX_WP} from "../../constants/fileNamePrefix";

export const getAllEntities = async () => {
  return base.get({
    url: API_PARAM.ENTITIES,
    params: { origin: env.REACT_APP_FILE_UPLOAD_ORIGIN_ID },
  });
};

export const getEntityDetails = async (id) => {
  return base.get({
    url: `${API_PARAM.ENTITIES}/${id}`,
  });
};

export const ExportEntityTemplate = async (
  entityId,
  entityName,
  templateName
) => {
  var fileName = `${FILE_NAME_PREFIX_WP}${renderToString(
    <Trans
      i18nKey={
        templateName
          ? "fileUploadWizard.fileUploadStep.downloadTemplateFileName"
          : "fileUploadWizard.fileUploadStep.downloadEntityTemplateFileName"
      }
      values={{
        name: templateName ?? entityName,
      }}
    />
  )}`;

  return base.exportFile({
    url: API_PARAM.EXPORT_TEMPLATE,
    data: entityId,
    fileName,
  });
};
